const PIXEL_ID = '1847425635830345'

let initialized = false

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel() {
  if (initialized) return

  const f = window
  const b = document
  const n = (f.fbq = function (...args: unknown[]) {
    if ((n as any).callMethod) {
      ;(n as any).callMethod.apply(n, args)
    } else {
      ;(n as any).queue.push(args)
    }
  })
  if (!f._fbq) f._fbq = n
  ;(n as any).push = n
  ;(n as any).loaded = true
  ;(n as any).version = '2.0'
  ;(n as any).queue = []

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)

  initialized = true
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Protocolo Varonil 45+',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
